import {
    SHOW_LOADING,
    HIDE_LOADING,
    GET_INSTANCE_TEMPLATE_LIST,
    ADD_INSTANCE_TEMPLATE,
    UPDATE_INSTANCE_TEMPLATE,
    INSTANCE_TEMPLATE_LIST,
    DELETE_INSTANCE_TEMPLATE,
    SET_INSTANCE_ADD_EDIT,
    INSTANCE_TEMPLATE_MESSAGE,
    GET_INSTANCE_TEMPLATE_PAGE_DRAFT_LIST,
    INSTANCE_TEMPLATE_PAGE_DRAFT_LIST,
    ADD_INSTANCE_TEMPLATE_PAGE_DRAFT,
    UPDATE_INSTANCE_TEMPLATE_PAGE_DRAFT,
    DELETE_INSTANCE_TEMPLATE_PAGE_DRAFT,
    INSTANCE_TEMPLATE_PAGE_DRAFT_MESSAGE,
    TAB_VALUE
  } from "redux/constants/templatePageInstance";
  
  export const getInstanceTemplateList = (requestData) => {
    return {
      type: GET_INSTANCE_TEMPLATE_LIST,
      payload: requestData,
    };
  };
  
  export const instanceTemplates = (instanceTemplates)=> {
      return {
          type: INSTANCE_TEMPLATE_LIST,
          payload: instanceTemplates,
        };
  }
  
  export const addInstanceTemplate = (data) => {
    return {
      type: ADD_INSTANCE_TEMPLATE,
      payload: data,
    };
  };
  
  export const updateInstanceTemplate = (data) => {
    return {
      type: UPDATE_INSTANCE_TEMPLATE,
      payload: data,
    };
  };
  
  export const deleteInstanceTemplate = (appInstanceTemplate) => {
      return {
        type: DELETE_INSTANCE_TEMPLATE,
        payload: appInstanceTemplate,
      };
    };
  
  export const showInstanceTemplateMessage= (response) =>{
    return {
      type: INSTANCE_TEMPLATE_MESSAGE,
      response,
    };
  }
  
  export const getInstanceTemplatePageDraftList = (requestData) => {
    return {
      type: GET_INSTANCE_TEMPLATE_PAGE_DRAFT_LIST,
      payload: requestData,
    };
  };
  
  export const instanceTemplatePagesDraft = (instanceTemplatePagesDraft)=> {
      return {
          type: INSTANCE_TEMPLATE_PAGE_DRAFT_LIST,
          payload: instanceTemplatePagesDraft,
        };
  }
  
  export const addInstanceTemplatePageDraft = (data) => {
    return {
      type: ADD_INSTANCE_TEMPLATE_PAGE_DRAFT,
      payload: data,
    };
  };
  
  export const updateInstanceTemplatePageDraft = (data) => {
    return {
      type: UPDATE_INSTANCE_TEMPLATE_PAGE_DRAFT,
      payload: data,
    };
  };
  
  export const deleteInstanceTemplatePageDraft = (appInstanceTemplatePageDraft) => {
      return {
        type: DELETE_INSTANCE_TEMPLATE_PAGE_DRAFT,
        payload: appInstanceTemplatePageDraft,
      };
    };
  
  export const showInstanceTemplatePageDraftMessage= (response) =>{
    return {
      type: INSTANCE_TEMPLATE_PAGE_DRAFT_MESSAGE,
      response,
    };
  }

  export const setAddEditInstancePages = (value) => {
      return {
          type: SET_INSTANCE_ADD_EDIT,
          addEditPageInstanceValue: value,
      };
  };
  
  export const showLoading = () => {
      return {
        type: SHOW_LOADING,
      };
    };
    
    export const hideLoading = () => {
      return {
        type: HIDE_LOADING,
      };
    };

    export const switchTabs = (value)=>{
      return {
        type: TAB_VALUE,
        selectedTab: value,
    };
    }